import { PERMISSIONS } from "@/services/permission"
import { CATALOG_PACKETS, PACKET_TYPES, packetListRoute } from "@/services/catalogPackets"

export default [
  // The packet lists each catalogue used to have beside its overview. Packets are now listed in the
  // catalogue's own table (`services/catalogPackets.js`); these forward there, filtered to packets and
  // with their query kept, so bookmarks and old links land on the same rows.
  ...PACKET_TYPES.map(type => ({
    path: CATALOG_PACKETS[type].packetsPath,
    name: CATALOG_PACKETS[type].packets,
    redirect: to => packetListRoute(type, to.query),
  })),
  // Every packet of every catalogue in one list. No drawer entry — the catalogues list their own
  // packets — but found by name in the command palette (`searchOnlyDestinations`).
  {
    path: "/packet/list",
    name: "PacketOverview",
    component: () => import("@/views/packet/PacketOverview"),
    meta: {
      title: "nav.packet.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_PACKET_GENERAL],
    },
  },
  // One view for the three create forms, which differ in nothing but the catalogue behind the picker.
  // The kind reaches it as a static route prop, so each keeps its own name and path — the palette, the
  // catalogue's create button, "Paket daraus erstellen" and "Duplizieren" all name these routes.
  ...PACKET_TYPES.map(type => ({
    path: CATALOG_PACKETS[type].createPath,
    name: CATALOG_PACKETS[type].create,
    component: () => import("@/views/packet/PacketCreate"),
    props: { type },
    meta: {
      title: CATALOG_PACKETS[type].createTitleKey,
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_PACKET_GENERAL],
    },
  })),
  {
    path: "/packet/:packetId",
    name: "PacketDetail",
    props: true,
    component: () => import("@/views/packet/PacketDetail"),
    meta: {
      title: "nav.packet.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_PACKET_GENERAL],
    },
  },
]
